<div class="container-fluid">

  <app-page-title [title]="'Image Prompt API'" [icon]="'bi-images'">
    <a class="btn btn-light" href="https://github.com/webmachinelearning/prompt-api" target="_blank"><i
      class="bi bi-file-text"></i> <span class="ms-2">Explainer</span></a>
    <a class="btn btn-light disabled"
       href=""
       target="_blank"><i class="bi bi-body-text"></i> <span class="ms-2">Specifications (Not yet available)</span></a>
  </app-page-title>

  <div class="row mb-3">
    <div class="col-12">

      <app-page-accordion
        [requirementsStatus]="this.apiFlag.status"
        (checkRequirementsEvent)="checkRequirements()"
        [requirements]="[this.apiFlag]"
      >
        <div debugInformation>
          <h5>Activate all the flags</h5>

          <table class="table">
            <thead>
              <tr>
                <th>Flag</th>
                <th>Value to select</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span class="code">chrome://flags/#optimization-guide-on-device-model</span></td>
                <td><span class="code code-info">Enabled Bypass*</span></td>
              </tr>
              <tr>
                <td><span class="code">chrome://flags/#prompt-api-for-gemini-nano-multimodal-input</span></td>
                <td><span class="code code-info">Enabled</span></td>
              </tr>
              <tr>
                <td><span class="code">chrome://flags/#optimization-guide-debug-logs</span></td>
                <td><span class="code code-info">Enabled</span></td>
              </tr>
            </tbody>
          </table>

          <h5 class="mt-4">Verify that Gemini Nano has been downloaded</h5>
          <ol style="line-height: 2;">
            <li>Navigate to <span class="code">chrome://components</span></li>
            <li>Search for <span class="code">Optimization Guide On Device Model</span> on the page.</li>
            <li>Click on <span class="code">Check for update</span></li>
            <li>Ensure that it says <span class="code code-info">Up-to-date</span></li>
          </ol>
        </div>

        <div faq>
          <h5>It seems like the page is stuck</h5>
          <p>After you have clicked on <button class="btn btn-sm btn-primary" (click)="execute()">Execute</button> for the first time, Chrome has to download Gemini Nano. This can take a while (5-10 minutes). While this is happening, the page can seem frozen or like nothing is happening. Give it time then try to restart your browser.</p>
        </div>
      </app-page-accordion>
    </div>
  </div>

  <h2 class="display-6 mt-5"><i class="bi bi-play"></i> Playground</h2>
  <hr>

  <app-output
    [status]="this.status"
    [error]="this.error"
    [downloadProgress]="this.loaded"
    [outputCollapsed]="outputCollapsed"
    [output]="this.output">

  </app-output>

  <div class="row mt-5">
    <div class="col-12">
      <h3>Prompt</h3>
      <div class="form-group">

        <code-editor></code-editor>

        <textarea id="prompt" class="form-control" rows="8" [formControl]="promptFormControl"></textarea>
      </div>
    </div>
  </div>

</div>
